;(function () {
  angular
    .module('contrast.applications-archive')
    .controller(
      'AppArchivePrimaryModalInstanceCtrl',
      AppArchivePrimaryModalInstanceCtrl
    )

  function AppArchivePrimaryModalInstanceCtrl(
    $scope,
    $routeParams,
    $uibModalInstance,
    $q,
    $filter,
    $translate,
    logger,
    ErrorService,
    ModuleFactory,
    ApplicationFactory,
    primaryApp
  ) {
    'ngInject'

    angular.extend($scope, {
      primaryApp: primaryApp,
      modules: [],
      model: {
        selected: []
      },
      orgUuid: $routeParams.orgUuid
    })

    angular.extend($scope, {
      archive: function () {
        var transl = {
          detail_archivePrimaryApplication_appsArchivedSuccessfully:
            $translate.instant(
              'detail_archivePrimaryApplication_appsArchivedSuccessfully'
            )
        }

        ApplicationFactory.archive($scope.primaryApp.app_id).then(
          function () {
            logger.logSuccess(
              transl.detail_archivePrimaryApplication_appsArchivedSuccessfully
            )
            $uibModalInstance.close()
          },
          function (response) {
            ErrorService.processError(response)
          }
        )
      },

      cancel: function () {
        $uibModalInstance.dismiss('cancel')
      },

      isSelected: function () {
        return $filter('filter')($scope.modules, { selected: true }).length > 0
      },

      unmergeAndArchive: function () {
        var transl = {
          detail_archivePrimaryApplication_appsUnmergedAndSelectedAppsArchived:
            $translate.instant(
              'detail_archivePrimaryApplication_appsUnmergedAndSelectedAppsArchived'
            )
        }

        var promises = []
        var selectedApps = $filter('filter')($scope.modules, { selected: true })
        var selectedPrimaryApp = $filter('filter')(selectedApps, {
          primary: true
        })

        if (selectedPrimaryApp.length == 1) {
          var request = ModuleFactory.removeChildsModule(
            selectedPrimaryApp[0].app_id
          )
          promises.push(request)
        } else {
          angular.forEach(selectedApps, function (app) {
            var request = ModuleFactory.removeModule(app.app_id)
            promises.push(request)
          })
        }

        $q.all(promises).then(
          function () {
            ApplicationFactory.archiveBatch(selectedApps).then(
              function () {
                logger.logSuccess(
                  transl.detail_archivePrimaryApplication_appsUnmergedAndSelectedAppsArchived
                )
                $uibModalInstance.close()
              },
              function (response) {
                ErrorService.processError(response)
              }
            )
          },
          function (errors) {
            ErrorService.processError(errors)
          }
        )
      }
    })

    function init() {
      $scope.primaryApp.selected = true
      $scope.modules.push($scope.primaryApp)

      ModuleFactory.getAppModules($scope.primaryApp.app_id).then(
        function (response) {
          angular.forEach(response.data.applications, function (app) {
            app.selected = true
            $scope.modules.push(app)
          })
        },
        function (response) {
          ErrorService.processError(response)
        }
      )
    }

    init()
  }
})()
